import React, { Suspense } from 'react';
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

import { STATE_LOGIN } from './components/AuthForm';
import { EmptyLayout, MainLayout } from './components/Layout';
import PageSpinner from './components/PageSpinner';
import AuthPage from './pages/AuthPage';
import PrivateRoutes from './PrivateRoutes';

import './styles/reduction.scss';
import { UIContextProvider } from './components/Context.js/UIContext.js';
import Loader from './components/Loader/Loader.js';
import SnackBar from './components/SnackBar/SnackBar.js';

const PurchaseOrderApproval = React.lazy(() =>
  import('./pages/PurchaseOrderApproval'),
);
const PurchaseOrder = React.lazy(() => import('./pages/PurchaseOrder'));
const Userpage = React.lazy(() => import('./pages/User'));
const PurchaseOrderView = React.lazy(() => import('./pages/PurchaseOrderView'));
const OutStandingBillReport = React.lazy(() =>
  import('./pages/OutStandingBillReport.js'),
);
const Dashboard = React.lazy(() => import('./pages/Dashboard'));
const Home = React.lazy(() => import('./pages/Home'));
const Changepassword = React.lazy(() => import('./pages/Changepassword'));
const Logout = React.lazy(() => import('./pages/Logout'));
const PurchaseOrderTracking = React.lazy(() =>
  import('./pages/Purchaseordertracking'),
);
const IndentView = React.lazy(() => import('./pages/IndentView'));
const Indent = React.lazy(() => import('./pages/Indent'));
const IndentApproval = React.lazy(() => import('./pages/IndentApproval'));
const DashboardPO = React.lazy(() => import('./pages/DashboardPO'));


const getBasename = () => {
  return `/${process.env.PUBLIC_URL.split('/').pop()}`;
};

const App = () => {
  // Get breakpoint based on screen width
  const isSm = useMediaQuery({ minWidth: 576, maxWidth: 767 });
  const isMd = useMediaQuery({ minWidth: 768, maxWidth: 991 });
  const isLg = useMediaQuery({ minWidth: 992, maxWidth: 1199 });
  const isXl = useMediaQuery({ minWidth: 1200 });

  let breakpoint = 'xs';
  if (isSm) breakpoint = 'sm';
  if (isMd) breakpoint = 'md';
  if (isLg) breakpoint = 'lg';
  if (isXl) breakpoint = 'xl';

  return (
    <UIContextProvider>
      <BrowserRouter basename={getBasename()}>
        <SnackBar />
        <Loader />
        <Routes>
          {/* Public Route with EmptyLayout */}
          <Route
            path="/"
            element={
              <EmptyLayout>
                <AuthPage authState={STATE_LOGIN} />
              </EmptyLayout>
            }
          />
          {/* <Route path="/changepassword" element={<Changepassword />} /> */}
          <Route
            path="/changepassword"
            element={
              <Suspense fallback={<PageSpinner />}>
                <Changepassword />
              </Suspense>
            }
          />


          {/* Private routes wrapped in PrivateRoutes and MainLayout */}
          <Route element={<PrivateRoutes />}>
            <Route
              element={
                <MainLayout breakpoint={breakpoint}>
                  <Suspense fallback={<PageSpinner />}>
                    <Outlet />
                  </Suspense>
                </MainLayout>
              }
            >
              <Route path="/login" element={<AuthPage />} />
              <Route path="/Dashboard" element={<Dashboard />} />
              <Route path="/PurchaseOrderApprovalView" element={<PurchaseOrderApproval />} />
              <Route path="/viewpo" element={<PurchaseOrderView />} />
              <Route path="/ViewIndent" element={<IndentView />} />
              <Route path="/IndentApproval" element={<IndentApproval />} />
              <Route path="/user" element={<Userpage />} />
              <Route path="/Home" element={<Home />} />
              <Route path="/logout" element={<Logout />} />

              <Route path="/Purchaseorder" element={<PurchaseOrder />} />
              <Route path="/IndentPurchaseOrder" element={<PurchaseOrder isIndent={true} />} />
              <Route path="/IndentPurchaseOrder/:id" element={<PurchaseOrder isIndent={true} />} />
              <Route path="/Purchaseorder/:id" element={<PurchaseOrder />} />
              <Route path="/Indent" element={<Indent />} />
              <Route path="/ApproveIndent/:id" element={<Indent isApproveView={true} />} />
              <Route path="/Indent/:id" element={<Indent />} />
              <Route path="/outstanding" element={<OutStandingBillReport />} />
              <Route path="/ApprovePurchaseOrder/:id" element={<PurchaseOrder isApproveView={true} />} />
              <Route
                path="/PurchaseordertrackingReport"
                element={<PurchaseOrderTracking />}
              />
              <Route
                path="/DashboardPO"
                element={<DashboardPO />}
              />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </UIContextProvider>
  );
};

export default App;
